import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { pluralize } from "@common/helpers/string";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { CommandsListProps } from "./lib";

export const OrgIntegrationBulkCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const {
        selectedOrgIntegrationAccountCount = 0,
        eligibleOrgIntegrationReminderCount = 0,
        eligibleOrgIntegrationClientCount = 0,
        eligibleOrgIntegrationEntityCount = 0,
        onOrgIntegrationBulkSendEmail,
        onOrgIntegrationBulkClearSelection,
        onOrgIntegrationBulkUpdateClient,
        onOrgIntegrationBulkUpdateEntity,
    } = options;

    const heading = `${selectedOrgIntegrationAccountCount} ${pluralize("account", selectedOrgIntegrationAccountCount)} selected`;

    return (
        <Command.Group heading={heading}>
            {onOrgIntegrationBulkSendEmail &&
                eligibleOrgIntegrationReminderCount > 0 && (
                    <CommandItem
                        keywords={["email", "remind", "reconnect", "nudge"]}
                        onSelect={onOrgIntegrationBulkSendEmail}
                    >
                        Send email ({eligibleOrgIntegrationReminderCount})
                    </CommandItem>
                )}
            {onOrgIntegrationBulkUpdateClient &&
                eligibleOrgIntegrationClientCount > 0 && (
                    <CommandItem
                        keywords={["client", "assign", "workspace"]}
                        onSelect={onOrgIntegrationBulkUpdateClient}
                    >
                        Update client ({eligibleOrgIntegrationClientCount})
                    </CommandItem>
                )}
            {onOrgIntegrationBulkUpdateEntity &&
                eligibleOrgIntegrationEntityCount > 0 && (
                    <CommandItem
                        keywords={["entity", "assign", "business"]}
                        onSelect={onOrgIntegrationBulkUpdateEntity}
                    >
                        Update entity ({eligibleOrgIntegrationEntityCount})
                    </CommandItem>
                )}
            {onOrgIntegrationBulkClearSelection && (
                <CommandItem
                    keywords={["clear", "deselect", "selection"]}
                    onSelect={onOrgIntegrationBulkClearSelection}
                >
                    Clear selection
                </CommandItem>
            )}
        </Command.Group>
    );
};
